import React, { FC } from 'react'
import slugify from 'slugify'
import { LabelProps } from './Label.types'

export const Label: FC<LabelProps> = ({
  label,
  name,
  disabled,
  style,
  children,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      width:'100%'
    }}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        width:'100%',
      }}
    >
      <label
        htmlFor={name ?? (typeof label === 'string' ? slugify(label, { lower: true }) : 'undefined')}
        style={{
          background: 'var(--background)',
          borderRadius: 4,
          width: 'fit-content',
          // zIndex: 100,
          fontSize: '0.8rem',
          color: disabled ? 'var(--slate11)' : 'var(--primary)' ,
          fill: disabled ? 'var(--slate11)' : 'var(--primary)',
          padding: '0px 4px',
          marginBottom: 0,
          backgroundColor: 'inherit',
          ...style
        }}
      >
        {label}
      </label>
    </div>
    {children}
  </div>
)

export default Label
